import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AdaptiveAccessControlNode, Header, Rule, Ruleset } from "@aptsi-types";

import { AdaptiveAccessNodeService } from "../../adaptive-access-node/adaptive-access-node.service";
import { RulesetService } from "../ruleset.service";
import { RuleService } from "../../rules/rules.service";
import { DeleteDialogComponent } from "../../shared/dialogs/delete-dialog/delete-dialog.component";
import { KeycloakStateService } from "src/app/core/service/utility.service";
@Component({
  selector: "app-node-popup",
  templateUrl: "./node-popup.component.html",
  styleUrls: ["./node-popup.component.scss"],
})
export class NodePopupComponent implements OnInit, OnChanges {
  // ==============================
  //  Dependency Injection
  // ==============================
  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      digitalId: string;
      path: string;
      orgnization: string;
      parentid: string;
      pathoverride: string;
      selectedEntries: any[];
    },
    private rulesetService: RulesetService,
    private adaptiveAccessControlService: AdaptiveAccessNodeService,
    private ruleService: RuleService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private keycloakStateService: KeycloakStateService
  ) {
    this.selectedEntries = data.selectedEntries || [];
  }

  // ==============================
  //  User Context
  // ==============================
  sessionId = this.keycloakStateService.getSessionId();
  userId = this.keycloakStateService.getUserId();

  // ==============================
  //  Tab Selection
  // ==============================
  selectedTab: "ruleset" | "rule" = "rule";

  // ==============================
  //  Lifecycle Hooks
  // ==============================
  async ngOnInit(): Promise<void> {
            const dropdownRulesetHeaders = this.rulesetheaders.filter(
      header => header.showInDropdown
    );

    if (dropdownRulesetHeaders.length > 1) {
      this.filterByHeader = dropdownRulesetHeaders[1].property;
    }
    
    const dropdownRuleHeaders = this.ruleheaders.filter(
      header => header.showInDropdown
    );

    if (dropdownRuleHeaders.length > 1) {
      this.filterByHeader = dropdownRuleHeaders[1].property;
    }

    await this.fetchRules();
    await this.fetchRulesets();
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selectedTab"]?.currentValue === "ruleset") {
      this.fetchRulesets();
    }
  }

  // ==============================
  //  Dialog Actions
  // ==============================
  closeDialog(): void {
    this.dialog.closeAll();
  }

  // ==============================
  //  Entry Selection
  // ==============================
  async onSelectEntry(index: number) {
    try {
      let selectedEntry: any = null;

      if (this.selectedTab === "rule") {
        selectedEntry = this.isrulesearch ? this.searchRuleData[index] : this.RuleData[index];
      } else {
        selectedEntry = this.isrulesetsearch ? this.searchRulesetData[index] : this.RulesetData[index];
      }

      if (selectedEntry) {
        this.rulesetService.addEntry(selectedEntry, this.data.parentid);
      }

      this.dialog.closeAll();
    } catch (error) {
      console.error("Error selecting entry:", error);
    }
  }

  // ==============================
  //  Rule Pagination & Data
  // ==============================
  RuleData: any[] = [];
  rules: Rule[] = [];
  selectedEntries: any[] = [];

  ruleheaders: Header[] = [
    { name: "Rule Id", property: "ruleid", showInDropdown: true },
    { name: "Rule Name", property: "name", showInDropdown: true },
    { name: "Rule Type", property: "type", showInDropdown: true },
  ];

  currentPageForRule = 1;
  itemsPerPageForRule = 7;
  totalPagesForRule = 0;
  totalPagesNormalForRule = 0;
  totalPagesSearchForRule = 0;

  isrulesearch = false;
  searchRuleText: string = null;
  filterByHeader: string = null;
  filteredRuleData: Rule[] = [];
  searchedRuleData: Rule[] = [];
  searchRuleData: any[] = [];

  get paginatedRuleData() {
    const start = (this.currentPageForRule - 1) * this.itemsPerPageForRule;
    const end = start + this.itemsPerPageForRule;
    return this.isrulesearch ? this.searchedRuleData.slice(start, end) : this.filteredRuleData.slice(start, end);
  }

async fetchRules() {
  try {
    const response = await this.ruleService
      .getRules(
        this.currentPageForRule - 1,
        this.sessionId,
        this.userId
      )
      .toPromise();

    const existingIds = this.collectExistingRuleIds(
      this.selectedEntries
    );

    this.filteredRuleData = response.filter(
      rule => !existingIds.has(rule.ruleId)
    );

    this.RuleData = this.filteredRuleData.map(rule => ({
      ruleId: rule.ruleId,
      ruleName: rule.ruleName,
      ruleType: rule.ruleType,
      children: [],
    }));

    // IMPORTANT FIX
    if (response.length > 0 && response[0].totalPages) {
      this.totalPagesNormalForRule = response[0].totalPages;
      this.totalPagesForRule = this.totalPagesNormalForRule;
      this.currentPageForRule = response[0].currentPage + 1;
    }

  } catch (error) {
    console.error("Error fetching rules:", error);
  }
}

  private collectExistingRuleIds(nodes: any[] = []): Set<string> {
  const ids = new Set<string>();

  const walk = (items: any[]) => {
    for (const item of items || []) {
      if (item?.ruleId) {
        ids.add(item.ruleId);
      }
      if (item?.children?.length) {
        walk(item.children);
      }
    }
  };

  walk(this.selectedEntries);
  return ids;
}

  async fetchRuleSearch() {
    try {
      const response = await this.ruleService
        .getRuleSearch(this.currentPageForRule - 1, this.searchRuleText, this.filterByHeader)
        .toPromise();

      this.searchedRuleData = [...response];

      this.searchRuleData = response.map(rule => ({
        ruleId: rule.ruleId,
        ruleName: rule.ruleName,
        ruleType: rule.ruleType,
        children: [],
      }));

      if (response.length > 0 && response[0].totalPages) {
        this.totalPagesSearchForRule = response[0].totalPages;
        this.totalPagesForRule = this.totalPagesSearchForRule;
        this.currentPageForRule = response[0].currentPage + 1;
      }
    } catch (error) {
      console.error("Error fetching rule search:", error);
    }
  }

  async searchRules() {
    if (this.searchRuleText) {
      this.isrulesearch = true;
      await this.fetchRuleSearch();
    } else {
      this.isrulesearch = false;
      await this.fetchRules();
    }
  }

  changeRulePage(page: number) {
    this.currentPageForRule = page;
    this.isrulesearch ? this.fetchRuleSearch() : this.fetchRules();
  }

  backRule() {
    if (this.isrulesearch) {
      this.isrulesearch = false;
      this.fetchRules();
    }
  }

  // ==============================
  //  Ruleset Pagination & Data
  // ==============================
  RulesetData: any[] = [];
  rulesets: Ruleset[] = [];

  rulesetheaders: Header[] = [
    { name: "Ruleset Id", property: "rulesetid", showInDropdown: true },
    { name: "Ruleset Name", property: "name", showInDropdown: true },
    { name: "Ruleset Type", property: "rulesetType", showInDropdown: true },
    { name: "Last Updated", property: "timestamp", showInDropdown: true },
  ];

  currentPageForRuleset = 1;
  itemsPerPageForRuleset = 7;
  totalPagesForRuleset = 0;
  totalPagesNormalForRuleset = 0;
  totalPagesSearchForRuleset = 0;

  isrulesetsearch = false;
  searchRulesetText: string = null;
  filteredRulesetData: Ruleset[] = [];
  searchedRulesetData: Ruleset[] = [];
  searchRulesetData: any[] = [];

  get paginatedRulesetData() {
    const start = (this.currentPageForRuleset - 1) * this.itemsPerPageForRuleset;
    const end = start + this.itemsPerPageForRuleset;
    return this.isrulesetsearch ? this.searchedRulesetData.slice(start, end) : this.filteredRulesetData.slice(start, end);
  }

  async fetchRulesets() {
    try {
      const response = await this.rulesetService.getRulesets(this.currentPageForRuleset - 1).toPromise();

      this.filteredRulesetData = [...response];

      this.RulesetData = response.map(rule => ({
        ruleId: rule.ruleId,
        ruleName: rule.ruleName,
        ruleType: rule.ruleType,
        children: [],
      }));

      if (response.length > 0 && response[0].totalPages) {
        this.totalPagesSearchForRuleset = response[0].totalPages;
        this.totalPagesForRuleset = this.totalPagesSearchForRuleset;
        this.currentPageForRuleset = response[0].currentPage + 1;
      }
    } catch (error) {
      console.error("Error fetching rulesets:", error);
    }
  }

  async fetchRulesetSearch() {
    try {
      const response = await this.rulesetService
        .getRulesetSearch(this.currentPageForRuleset - 1, this.searchRulesetText, this.filterByHeader)
        .toPromise();

      this.searchedRulesetData = [...response];

      this.searchRulesetData = response.map(rule => ({
        ruleId: rule.ruleId,
        ruleName: rule.ruleName,
        ruleType: rule.ruleType,
        children: [],
      }));

      if (response.length > 0 && response[0].totalPages) {
        this.totalPagesSearchForRuleset = response[0].totalPages;
        this.totalPagesForRuleset = this.totalPagesSearchForRuleset;
        this.currentPageForRuleset = response[0].currentPage + 1;
      }
    } catch (error) {
      console.error("Error fetching ruleset search:", error);
    }
  }

  async searchRulesets() {
    if (this.searchRulesetText) {
      this.isrulesetsearch = true;
      await this.fetchRulesetSearch();
    } else {
      this.isrulesetsearch = false;
      await this.fetchRulesets();
    }
  }

  changeRulesetPage(page: number) {
    this.currentPageForRuleset = page;
    this.isrulesetsearch ? this.fetchRulesetSearch() : this.fetchRulesets();
  }

  backRuleset() {
    if (this.isrulesetsearch) {
      this.isrulesetsearch = false;
      this.fetchRulesets();
    }
  }

  // ==============================
  //  Miscellaneous
  // ==============================
  adaptiveaccessnodes: AdaptiveAccessControlNode[] = [];
  nullver: number = null;
  entries = [
    { id: 1, name: "John Doe", age: 28 },
    { id: 2, name: "Jane Smith", age: 34 },
    { id: 3, name: "Alex Johnson", age: 22 },
  ];
}

